<template>
  <div class="aiplatformBanner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">降低AI技术门槛 释放AI技术潜力</span>
        <p>MoPaaS 智能云平台赋能数字化未来</p>
        <div class="try-btn-area">
          <a href="https://ai.mopaas.com" target="_blank">
            <div class="btn-contactUs">立即体验</div>
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'AiPlatformBanner',
  }
</script>

<style>
  .aiplatformBanner {
    width: 100%;
    height: 38.49vw;
    margin-top: 72px;
    overflow-y: hidden;
    background-image: url("../assets/images/newaibanner.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .aiplatformBanner .center {
    width: auto !important;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 13.54vw;
  }

  .aiplatformBanner .banner-overlay1 {
    padding-top: 8.5vw;
    color: #FFFFFF;
    text-align: left;
  }


  .aiplatformBanner .banner-overlay1 .title {
    width: 710px;
    height: 63px;
    font-size: 50px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 63px;
    display: inline-block;
  }

  .aiplatformBanner .banner-overlay1 p {
    width: 389px;
    height: 40px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
    opacity: 0.7;
    margin-top: 21px;
  }

  .aiplatformBanner .btn-contactUs {
    margin-top: 4.53vw;
    cursor: pointer;
    color: #ffffff;
    width: 168px;
    height: 58px;
    border-radius: 29px;
    background: linear-gradient(90deg, rgba(39, 46, 63, 0.38) 0%, rgba(33, 36, 51, 0.34) 100%), url('../assets/images/svg/btnborder.svg');
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 400;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/AiPlatformBanner.vue